__turbopack_context__.v({
  "arrowAfter": "HIHButton-module-scss-module__pO_8_G__arrowAfter",
  "arrowAfterIcon": "HIHButton-module-scss-module__pO_8_G__arrowAfterIcon",
  "arrowBefore": "HIHButton-module-scss-module__pO_8_G__arrowBefore",
  "dark": "HIHButton-module-scss-module__pO_8_G__dark",
  "hihButton": "HIHButton-module-scss-module__pO_8_G__hihButton",
  "iconAfter": "HIHButton-module-scss-module__pO_8_G__iconAfter",
  "iconBefore": "HIHButton-module-scss-module__pO_8_G__iconBefore",
  "label": "HIHButton-module-scss-module__pO_8_G__label",
  "lg": "HIHButton-module-scss-module__pO_8_G__lg",
  "loading": "HIHButton-module-scss-module__pO_8_G__loading",
  "md": "HIHButton-module-scss-module__pO_8_G__md",
  "outline": "HIHButton-module-scss-module__pO_8_G__outline",
  "secondary": "HIHButton-module-scss-module__pO_8_G__secondary",
  "sm": "HIHButton-module-scss-module__pO_8_G__sm",
});
